export const CorePaleBGPaletteLight: any = {
    0: '#E5E7EB',
    1: '#FFDBEA',
    2: '#FFDBEA',
    3: '#FEDDF8',
    4: '#E8E1FE',
    5: '#E8E1FE',
    6: '#DBF3FF',
    7: '#DBF3FF',
    8: '#DBF3FF',
    9: '#D6F7F3',
    10: '#D6F5DE',
    11: '#D6F5DE',
    12: '#D6F5DE',
    13: '#D6F7F3',
    14: '#FFF1C7',
    15: '#FFEEE0',
    16: '#FFE2E0',
    17: '#E5E7EB',
    18: '#E5E7EB',
    19: '#F4E4DD',
    20: '#EBF0FF',
    21: '#EBF0FF',
    22: '#E8E1FE',
    23: '#E5E7EB',
    24: '#E8E1FE',
    25: '#E5E7EB',
    26: '#FFDBEA',
    27: '#DDE2FA',
    28: '#D4F7FC',
    29: '#D3FDE7',
    30: '#CCEAD8',
    31: '#EEF8D7',
    32: '#FFCECD',
    33: '#FFD2F5',
    34: '#F0D4F4',
    35: '#E4CCF3',
    36: '#DCD0F5',
    37: '#EAD0D0',
    38: '#DDD7D7',
}